module.exports = __webpack_public_path__ + "ca3ebfd9746696bc7986d5362e4c4c32.jpg";